<template>
  <div class="Container">
    <h2 class="ViewHeading">Water Testing</h2>

    <b-modal
      ref="RiskAssessmentPreModal"
      id="RiskAssessmentPreModal"
      title="Water Test Pre Questionnaire"
      content-class="Modal"
      header-bg-variant="light"
      header-text-variant="dark"
      size="lg"
      hide-footer
    >
      <b-card v-if="this.ScheduledRiskAssessmentItems.length == 0">
        <p>
          There are no current Scheduled Water Tests for this location.
        </p>
        <p>Press submit to proceed with a new Water Test.</p>
      </b-card>
      <b-card v-if="this.ScheduledRiskAssessmentItems.length > 0">
        <p>
          There are Water Tests scheduled for this location, please select if
          you are completing one of the below:
        </p>
        <br />
        <b-table
          sticky-header
          no-border-collapse
          responsive
          :items="ScheduledRiskAssessmentItems"
          :fields="ScheduledRiskAssessmentFields"
          hover
          small
        >
          <template v-slot:cell(Selected)="{ item }">
            <section v-on:click="ResetWithoutScheduled()">
              <b-form-checkbox v-model="item.Selected"></b-form-checkbox>
            </section>
          </template>
        </b-table>
      </b-card>
      <br />
      <b-row>
        <b-col cols="10">Proceed without Scheduled Appointment</b-col>
        <b-col cols="2"
          ><b-form-checkbox v-model="WithoutScheduled"></b-form-checkbox
        ></b-col>
      </b-row>

      <b-row>
        <b-col
          ><b-button v-on:click="PreAssessmentSubmit()" variant="outline-info"
            >Submit</b-button
          ></b-col
        >
        <b-col
          ><b-button v-on:click="PreAssessmentCancel()" variant="outline-info"
            >Cancel</b-button
          ></b-col
        >
      </b-row>
    </b-modal>
    <b-modal
      ref="WaterTestInfoModal"
      id="WaterTestInfoModal"
      title="Water Test Information"
      content-class="Modal"
      header-bg-variant="light"
      header-text-variant="dark"
      no-close-on-backdrop
      no-close-on-esc
      size="lg"
    >
      <h5>Test Information</h5>
      <b-row>
        <b-col cols="6"> <b> Test ID </b> </b-col>
        <b-col cols="6"> <b> Sample ID </b> </b-col>
      </b-row>
      <b-row>
        <b-col cols="6"> {{ this.TestID }} </b-col>
        <b-col cols="6"> {{ this.SampleID }} </b-col>
      </b-row>
    </b-modal>
    <b-card>
      <b-button
        variant="info"
        v-on:click="ServiceRequestInfo(), ShowEntryModal()"
        size="sm"
        >Register New Water Sample</b-button
      >
      <section v-if="this.ChosenAppointment != ''">
        <b-row>
          <b-col>
            {{ this.selectedlocation }}
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="3">Rapid or Colony</b-col>
          <b-col cols="3">
            <select v-model="SpeedofTest">
              <option value="Rapid" select>Rapid </option>
              <option value="Colony" select>Colony </option>
            </select></b-col
          >
          <b-col cols="3">Legionella or Pseudomonas</b-col>
          <b-col cols="3">
            <select v-model="TypeofTest">
              <option value="Legionella" select>Legionella </option>
              <option value="Pseudomonas" select>Pseudomonas </option>
            </select></b-col
          >
        </b-row>

        <b-row>
          <b-col cols="3">Sample Position</b-col>
          <b-col cols="3"
            ><select v-model="devicePosition">
              <option value="" select disabled>Select Position</option>
              <option
                v-for="(value, id) in this.PositionArray"
                :key="id"
                v-bind:value="{ id: value.id, text: value.value }"
                >{{ value.value }}</option
              >
            </select></b-col
          >
          <b-col cols="3">Outlet ID</b-col>
          <b-col cols="3">
            <!-- <select v-model="OutletID">
              <option value="Hot" select>Hot </option>
              <option value="Cold" select>Cold </option>
              <option value="Mixed" select>Mixed </option>
              <option value="Return" select>Return </option>
            </select> -->

            <input
              type="text"
              placeholder="Outlet ID"
              v-model="OutletID"
              required
              @focus="modal = false"
            />
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="3">Sample Date</b-col>
          <b-col cols="3">
            <b-form-datepicker
              class="DatePickerInstaller"
              type="date"
              v-model="selectedDate"
              :placeholder="selectedDate"
              @focus="modal = false"
          /></b-col>
          <b-col cols="3">Sample Time</b-col>
          <b-col cols="3">
            <b-form-timepicker
              id="TimeRaised"
              v-model="selectedTime"
            ></b-form-timepicker
          ></b-col>
        </b-row>
        <b-row>
          <b-col cols="3">Post/Pre Flush</b-col>
          <b-col cols="3">
            <select v-model="TypeofFlush">
              <option value="Post" select>Post </option>
              <option value="Pre" select>Pre </option>
            </select></b-col
          >
          <b-col cols="3">Description</b-col>
          <b-col cols="3"
            ><div class="textarea-loc">
              <textarea
                v-model="Description"
                placeholder="Extra Information"
                rows="3"
                cols="28"
                @focus="modal = false"
                maxlength="75"
              ></textarea></div
          ></b-col>
        </b-row>
        <b-row>
          <b-button variant="outline-info" v-on:click="BeginWaterTest()">
            Submit
          </b-button>
          <b-button variant="outline-info" v-on:click="resetFunction()">
            Cancel
          </b-button>
        </b-row>
      </section>
    </b-card>
  </div>
</template>

<script>
import axios from "axios";

export default {
  computed: {},
  components: {},

  data() {
    return {
      dataToDisplay: [],
      UserURN: localStorage.getItem("UserURN"),
      UserProfile: localStorage.getItem("ProfilePortal"),
      clCompany: localStorage.getItem("Company"),
      nickname: localStorage.getItem("Nickname"),
      ScheduledRiskAssessmentItems: [],
      selectedlocation: localStorage.getItem("location"),
      ScheduledRiskAssessmentFields: [
        { key: "Date", label: "Date" },
        { key: "Room", label: "Room Area" },
        { key: "LocationNote", label: "Location Note" },
        { key: "Selected", label: "" },
      ],
      ChosenAppointment: "",
      SpeedofTest: "",
      TypeofTest: "",
      devicePosition: "",
      PositionArray: [],
      feedArray: [],
      OutletType: "",
      selectedDate: "",
      selectedTime: "",
      TypeofFlush: "",
      Description: "",
      ServiceNote: "",
      dateOptions: { day: "numeric", month: "numeric", year: "numeric" },
      OutletID: "",
      SampleID: "",
      TestID: "",
      WithoutScheduled: "",
    };
  },

  beforeMount() {},

  mounted() {
    let LookUpUrl2 =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeaders2 = this.$apikeyPost;
    this.LookUpRequest = { RequestType: "PositionFeed" };
    axios
      .post(LookUpUrl2, this.LookUpRequest, LookUpHeaders2)
      .then((response) => {
        this.feedList = response.data.Feeds;
        this.Positions = response.data.Positions;
        for (let i = 0; i < this.feedList.length; i++) {
          var QuoteStr = this.feedList[i][0];
          this.feedArray.push({ id: QuoteStr, value: this.feedList[i][1] });
        }
        for (let i = 0; i < this.Positions.length; i++) {
          var QuoteStr2 = this.Positions[i][0];
          this.PositionArray.push({
            id: QuoteStr2,
            value: this.Positions[i][1],
          });
        }
      });
    this.ServiceRequestInfo();
  },

  methods: {
    ServiceRequestInfo() {
      let LookUpUrlScheduledTests =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersScheduledTests = this.$apikeyPost;
      let LookUpRequestScheduledTests = {
        ServiceType: "WaterTesting",
        RequestType: "ScheduledTests",
        DataDict: [
          {
            Location: this.selectedlocation,
          },
        ],
      };
      axios
        .post(
          LookUpUrlScheduledTests,
          LookUpRequestScheduledTests,
          LookUpHeadersScheduledTests
        )
        .then((response) => {
          let RiskAssessArray = [];
          this.ScheduledRiskAssessmentItems = [];
          RiskAssessArray = response.data.Values;

          for (let i = 0; i < RiskAssessArray.length; i++) {
            this.ScheduledRiskAssessmentItems.push({
              ID: RiskAssessArray[i][0],
              ServiceNote: RiskAssessArray[i][3],
              ArrangedBy: RiskAssessArray[i][6],
              Time: RiskAssessArray[i][8],
              ContactName: RiskAssessArray[i][9],
              ContactEmail: RiskAssessArray[i][10],
              ContactNote: RiskAssessArray[i][11],
              Date: RiskAssessArray[i][7],
              Room: RiskAssessArray[i][4],
              LocationNote: RiskAssessArray[i][5],
              Selected: false,
            });
          }
        });
    },

    ShowEntryModal() {
      this.$refs["RiskAssessmentPreModal"].show();
    },

    BeginWaterTest() {
      let LookUpUrlScheduledTests =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/wms";
      let LookUpHeadersScheduledTests = this.$apikeyPost;
      let LookUpRequestScheduledTests = {
        ServiceType: "WaterTesting",
        RequestType: "AddWaterTest",
        DataDict: [
          {
            Location: this.selectedlocation,
            Category: this.SpeedofTest,
            TestType: this.TypeofTest,
            TestDesc: this.Description,
            FlushType: this.TypeofFlush,
            OutletType: this.devicePosition.text,
            OutletID: this.OutletID,
            SampleDate: this.selectedDate,
            SampleTime: this.selectedTime,
            ServiceID: "",
            AssignedTo: "",
          },
        ],
      };
      axios
        .post(
          LookUpUrlScheduledTests,
          LookUpRequestScheduledTests,
          LookUpHeadersScheduledTests
        )
        .then((response) => {
          this.SampleID = response.data.SampleID;
          this.TestID = response.data.TestID;

          // WaterTestInfoModal
          this.$refs["WaterTestInfoModal"].show();

          this.resetFunction();
        });
    },

    resetFunction() {
      this.OutletID = "";
      this.SpeedofTest = "";
      this.TypeofTest = "";
      this.TypeofFlush = "";
      this.Description = "";
      this.OutletType = "";
      this.selectedDate = "";
      this.selectedTime = "";
      this.showQuestions = "false";
      this.devicePosition = [];
      this.ChosenAppointment = "";
      this.RiskAssessArray = [];
      // this.PreAssessmentSubmit();
    },

    PreAssessmentSubmit() {
      this.ChosenAppointment = "";

      if (this.ScheduledRiskAssessmentItems.length == 0) {
        this.ChosenAppointment = "None";
      } else if (this.ScheduledRiskAssessmentItems.length > 0) {
        for (let u = 0; u < this.ScheduledRiskAssessmentItems.length; u++) {
          if (this.ScheduledRiskAssessmentItems[u].Selected == true) {
            this.ChosenAppointment = this.ScheduledRiskAssessmentItems[u].ID;
            this.selectedDate = this.ScheduledRiskAssessmentItems[u].Date;
            this.selectedTime = this.ScheduledRiskAssessmentItems[u].Time;
            this.Description = this.ScheduledRiskAssessmentItems[
              u
            ].LocationNote;
            this.ServiceNote = this.ScheduledRiskAssessmentItems[u].ServiceNote;

            // this.AssessmentObject.Details.Date = this.ScheduledRiskAssessmentItems[
            //   u
            // ].Date;
            // this.AssessmentObject.Details.Room = this.ScheduledRiskAssessmentItems[
            //   u
            // ].Room;
            // this.AssessmentObject.Details.Assessor = this.name;
            // this.AssessmentObject.Details.LocationNote = this.ScheduledRiskAssessmentItems[
            //   u
            // ].LocationNote;
            // this.AssessmentObject.Details.Time = this.ScheduledRiskAssessmentItems[
            //   u
            // ].Time;
            // this.AssessmentObject.Details.ServiceNote = this.ScheduledRiskAssessmentItems[
            //   u
            // ].ServiceNote;
            // this.AssessmentObject.Details.ArrangedBy = this.ScheduledRiskAssessmentItems[
            //   u
            // ].ArrangedBy;
            // this.AssessmentObject.Details.ContactName = this.ScheduledRiskAssessmentItems[
            //   u
            // ].ContactName;
            // this.AssessmentObject.Details.ContactEmail = this.ScheduledRiskAssessmentItems[
            //   u
            // ].ContactEmail;
            // this.AssessmentObject.Details.ContactNote = this.ScheduledRiskAssessmentItems[
            //   u
            // ].ContactNote;
            break;
          } else {
            this.ChosenAppointment = "None";
          }
        }
      }

      this.$refs["RiskAssessmentPreModal"].hide();
      this.showQuestions = "true";
    },
    PreAssessmentCancel() {
      this.$refs["RiskAssessmentPreModal"].hide();
    },
    resetSelectedPreExist() {
      for (let u = 0; u < this.ScheduledRiskAssessmentItems.length; u++) {
        if (this.ScheduledRiskAssessmentItems[u].Selected == true) {
          this.ScheduledRiskAssessmentItems[u].Selected = false;
        }
      }
    },

    ResetWithoutScheduled() {
      this.WithoutScheduled = false;
    },

    //  OLD
    getDataToAction() {},
    DeviceAction() {},
  },
  watch: {
    WithoutScheduled() {
      this.resetSelectedPreExist();
    },
  },
};
</script>

<style scoped>
div {
  float: left;
  width: 100%;
  padding: 10px;
}
</style>
